// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"5bfbbaa3abbef25c3a0d","883":"8418e948c6af4847a834"}[chunkId] + ".js";
};